"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveMarkedJson = void 0;
const prefix = `json://`;
const prefixLength = prefix.length;
function resolveMarkedJson(value) {
    if (typeof value === 'string' && value.startsWith(prefix)) {
        return value.slice(prefixLength);
    }
    return null;
}
exports.resolveMarkedJson = resolveMarkedJson;
